import { render, staticRenderFns } from "./Myexamind.vue?vue&type=template&id=26931fd2&scoped=true"
import script from "./Myexamind.vue?vue&type=script&lang=js"
export * from "./Myexamind.vue?vue&type=script&lang=js"
import style0 from "./Myexamind.vue?vue&type=style&index=0&id=26931fd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26931fd2",
  null
  
)

export default component.exports